enum Datetime {
    dateFormat = 'YYYY-MM-DD',
    dateTimeFormat = 'YYYY-MM-DD HH:mm',
    dateTimeSecondsFormat = 'YYYY-MM-DD HH:mm:ss',
    dateTimeSecondsMillisecondsFormat = 'YYYY-MM-DD HH:mm:ss.SSS',
    timeFormat = 'HH:mm',
    timeSecondsFormat = 'HH:mm:ss',
}

export default Datetime;
